import {values} from 'lodash';
import {GTM_EVENTS} from 'app/model/gtmEvents';

export const gtmEventPusher = (event) => {
    if (!window.dataLayer) {
        console.warn('Cannot found gtm data layer'); // eslint-disable-line

        return;
    }

    if (!values(GTM_EVENTS).includes(event)) {
        throw new TypeError('You have to provide valid GTM Event name. See app/model/gtmEvents.js');
    }

    return window.dataLayer.push({event});
};
